import react1 from '../assets/icons/react1.svg';
import technology from '../assets/icons/technology.svg';
import linux from '../assets/icons/linux.svg';
import server from '../assets/icons/server.svg';
import basketball from '../assets/icons/basketball.svg';
import guitar from '../assets/icons/guitar.svg';

const skills = [
  {
    icon: react1,
    title: 'React developer',
    about:
      'The most popular and widely used JS Framework, React. My weapon of choice.',
    id: 2,
  },
  {
    icon: technology,
    title: 'Passionate about IT',
    about: ['I like being able to challenge myself and apply new technologies'],
    id: 1,
  },
  {
    icon: linux,
    title: 'Linux lover',
    about:
      'More than 15 years since I fell in love with Linux and its many distributions.',
    id: 3,
  },
  {
    icon: server,
    title: 'Back-End Development',
    about: `I'm currently studing Back-end development focusing on NodeJS.`,
    id: 4,
  },
  {
    icon: basketball,
    title: 'Sports',
    about: `I'm a basketball fan and I currently play in a small local team.`,
    id: 5,
  },
  {
    icon: guitar,
    title: 'Music',
    about:
      'I love music, and on my free time I like to play the guitar and the drums.',
    id: 6,
  },
];

export { skills };
